<div class="copy-note-dialog">
  <div class="modal-header">
    <h3 class="modal-title">
      Copy foot note to..
      <i class="fa fa-times pull-right" (click)="close()"></i>
      <i class="fa pull-right toggle-icon"
         [ngClass]="{'fa-plus-square-o': minimised, 'fa-minus-square-o': !minimised}"
         (click)="minimised = !minimised"></i>
    </h3>
  </div>

  @if (!minimised) {
<div class="modal-body app-foot-eng">
    <!-- Form controls -->
    @if (!state.icon) {

      <!-- Corporation Type -->
      <div class="row mt-10">
        <div class="col-md-3 ft-label">
          <span>Corporation Type</span>
        </div>
        <div class="col-md-9">
          <div class="btn-group" role="group">
            <button type="button" class="btn filter-selection filter-btn"
                    [class.active]="selectedFilterType === 'C'"
                    (click)="selectedFilterType = 'C'"
                    disabled>
              Corporation
            </button>
            <button type="button" class="btn filter-selection filter-btn"
                    [class.active]="selectedFilterType === 'P'"
                    (click)="selectedFilterType = 'P'">
              Partnership
            </button>
          </div>
        </div>
      </div>

      <!-- System Flag -->
      <div class="row mt-10">
        <div class="col-md-3 ft-label">
          <span>System Flag</span>
        </div>
        <div class="col-md-9">
          @if (selectedFilterType === 'C') {
<div class="filters-corp">
            <span>Footnotes are not available for Corporation!</span>
          </div>
}
          <div class="btn-group" role="group">
            <button type="button" class="btn filter-selection filter-btn active">
              Domestic
            </button>
            <button type="button" class="btn filter-selection filter-btn" disabled>
              Foreign
            </button>
          </div>
        </div>
      </div>

      <!-- Partnership (HO) -->
      <div class="row mt-10">
        <div class="col-md-3 ft-label">
          <span>Partnership</span>
        </div>
        <div class="col-md-9">
          <select class="pad-adjust form-control-sm"
                  [(ngModel)]="selectedHO"
                  [compareWith]="compareHO"
                  (ngModelChange)="changeHO()">
            @for (ho of hoList; track $index) {
<option [ngValue]="ho">{{ho.name}}</option>
}
          </select>
        </div>
      </div>

      <!-- Form -->
      <div class="row mt-10">
        <div class="col-md-3 ft-label">
          <span>Form</span>
        </div>
        <div class="col-md-9">
          <select class="pad-adjust form-control-sm"
                  [(ngModel)]="selectedForm"
                  (ngModelChange)="changeForm()"
                  [disabled]="partnersLoading">
            @for (form of formList; track $index) {
<option [ngValue]="form.form">{{form.form}}</option>
}
          </select>
        </div>
      </div>

      <!-- Schedule -->
      @if (!hideSchedules) {
<div class="row mt-10">
        <div class="col-md-3 ft-label">
          <span>Schedule</span>
        </div>
        <div class="col-md-9">
          <select class="pad-adjust form-control-sm"
                  [(ngModel)]="selectedSchedule"
                  [disabled]="partnersLoading">
            @for (sch of scheduleList; track $index) {
<option [ngValue]="sch">{{sch}}</option>
}
          </select>
        </div>
      </div>
}

      <!-- Partner (multiselect) -->
      @if (selectedSchedule !== 'NA' && !hidePartners) {
<div class="row mt-10">
        <div class="col-md-3 ft-label">
          <span>Partner</span>
        </div>
        <div class="col-md-9">
          @if (!partnersLoading) {
<div class="partner-multiselect">
            <div class="partner-select-header" (click)="partnerDropOpen = !partnerDropOpen">
              <span class="partner-select-text">
                @if (selectedPartners.length === 0) {
Select partners
}
                @if (selectedPartners.length === 1) {
{{selectedPartners[0].le_name || 'Select partners'}}
}
                @if (selectedPartners.length > 1) {
{{selectedPartners.length}} selected
}
              </span>
              <span class="caret"></span>
            </div>
            @if (partnerDropOpen) {
<div class="partner-dropdown">
              <input type="text" class="partner-search" placeholder="Search..."
                     [(ngModel)]="partnerSearch" (click)="$event.stopPropagation()">
              <div class="partner-actions">
                <a (click)="selectAllPartners(); $event.stopPropagation()">Select all</a>
                <a (click)="deselectAllPartners(); $event.stopPropagation()">Unselect all</a>
              </div>
              <div class="partner-list">
                @for (partner of partners; track $index) {
<label
                       [hidden]="partnerSearch && !partner.le_name?.toLowerCase().includes(partnerSearch.toLowerCase())">
                  <input type="checkbox"
                         [checked]="isPartnerSelected(partner)"
                         (change)="togglePartner(partner)">
                  {{partner.le_name}}
                </label>
}
              </div>
            </div>
}
          </div>
}
          @if (partnersLoading) {
<span>Loading partners...</span>
}
        </div>
      </div>
}
    
}

    <!-- State indicator -->
    @if (state.icon) {
<div class="state-indicator">
      <i class="fa" [ngClass]="state.icon" aria-hidden="true"></i>
      <div>{{state.text}}</div>
    </div>
}

    <!-- Copy button -->
    <div class="row mt-10">
      <div class="col-md-12">
        @if (!hideCopy) {
<button class="btn btn-success btn-xs filter-btn pull-right copy-btn"
                [disabled]="disableCopy()"
                (click)="copy()"
               >
          Copy
        </button>
}
      </div>
    </div>
  </div>
}
</div>
